import LogoSVG from './images/LogoFooter';
import LogoLink from './LogoLink';

const LogoFooter = (props) => {
  return <LogoLink image={<LogoSVG />} {...props} />;
};

export default LogoFooter;
